<template>
    <div id="caseProgBox">        
        <div class="searchWrap">
            <div class="row">                       
                <div class="itemWrap" style="width:100%">
                    <label>資料來源</label>
                    <el-select v-model="listQuery.DataSource" placeholder="請選擇資料來源" clearable style="width: 200px;" @change="handleDataSourceChange">
                        <el-option label="全部" value="全部"></el-option>
                        <el-option label="總行派案" value="總行派案"></el-option>
                        <el-option label="續約重訂" value="續約重訂"></el-option>                        
                        <el-option label="自行開發" value="自行開發"></el-option>                        
                    </el-select>
                </div>                    
                <div class="itemWrap">
                    <label>專案名稱</label>
                    <el-select v-model="listQuery.ProjectName" placeholder="請選擇專案名稱" clearable style="width: 200px;" >
                        <el-option label="全部" value="全部"></el-option>
                        <el-option v-for="item in filteredProjectNameList" :key="item.ID" :label="item.ProjectName" :value="item.ProjectName"></el-option>                        
                    </el-select>
                </div>
                <div class="itemWrap">                    
                     <label class="datePickerClass">專案區間: </label>
                        <el-date-picker
                        v-model="dt"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="閞始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions">
                        </el-date-picker>
                    
                    
                </div>
                <div class="itemWrap">
                    <el-button type="primary" icon="el-icon-search" @click.native="doSearch">查詢</el-button>
                </div>
                
            </div>
        </div>

        <div class="content" >
            <el-table ref="multipleTable" border :cell-style="{padding: '3px'}" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" style="width: 100%"  empty-text="暫無數據" :data="tableData" @select="handleSelectionChange">                            
                <el-table-column label="資料來源"  prop="DataSource" min-width="20%">
                </el-table-column>                              
                <el-table-column label="專案名稱" prop="ProjectName"  min-width="20%">                
                    <template slot-scope="scope">
                        <span class="clickable-text" @click="projectDetailHandler(scope.row)">{{ scope.row.ProjectName }}</span>
                    </template>
                </el-table-column>              
                <el-table-column label="分行ID"  prop="DeptID" min-width="20%"  >
                </el-table-column>                                                             
                <el-table-column label="負責分行"  prop="DeptName" min-width="20%"  >
                </el-table-column>                                             
                <el-table-column label="建立時間"  prop="CreateDt" min-width="20%"  >
                </el-table-column>                                                                                                                 
            </el-table>
            <div class="pageBox">
                <Pagination
                    @currentChange="pageChange"
                    :pageSize="this.listQuery.Page_Size"
                    :propsCurrentPage="this.listQuery.Page_Num"
                    :totalLists="totalLists">
                </Pagination>
            </div>                          
        </div>

        <!-- Dialog -->
        <el-dialog 
            :title="`專案名稱：${selectedRow ? selectedRow.ProjectName : ''} - 訪視統計`" 
            :visible.sync="projectDetailVisible" 
            width="50%"
            :before-close="handleClose">
            <div class="dialogBox">
                <div class="row1" v-if="btnDivVisible">
                    <div class="itemBox">
                        <span >區處分行</span>
                        <DivSelection v-model="DivisionCode"  :filterDivisionCode="filterDivisionCode" @branch-selected="handleDivChange" :style="{ width: '250px', marginLeft: '10px' }" />
                    </div>
                    <div class="itemBox">
                        <el-button type="primary" icon="el-icon-search" @click="doSearchVisit()">查詢</el-button>
                        <el-button type="danger" icon="el-icon-plus" @click="exportExcel">匯出</el-button>          
                    </div>
                </div>
                <div class="row1" >                    
                    <el-tabs tab-position="top" type="border-card" style="background:transparent;width:100%;height: 100%;" stretch >                        
                        <el-tab-pane label="訪視完成統計">
                            <el-descriptions  :column="12" border>
                                <!-- <el-descriptions-item label="區處" :span="6" ><span class="dCont">{{ CaseVisit.DivisionName }}</span></el-descriptions-item>
                                <el-descriptions-item label="分行代號" :span="6"  ><span class="dCont">{{ CaseVisit.DeptID }}</span></el-descriptions-item> -->
                                <el-descriptions-item label="訪視名單" :span="3" ><span class="dCont">{{ CaseVisit.VisitTotal}}</span></el-descriptions-item>
                                <el-descriptions-item label="已完成訪視" :span="3" ><span class="dCont">{{ CaseVisit.VisitComplete }}</span></el-descriptions-item>
                                <el-descriptions-item label="未完成訪視" :span="3" ><span class="dCont">{{ CaseVisit.VisitIncomplete}}</span></el-descriptions-item>
                                <el-descriptions-item label="已完成訪視%" :span="3" ><span class="dCont">{{ CaseVisit.VisitCompleteRate }}</span></el-descriptions-item>
                                <el-descriptions-item label="ELN核准" :span="6" ><span class="dCont">{{ CaseVisit.ELNApproved }}</span></el-descriptions-item>
                                <!-- <el-descriptions-item label="ELN駁件" :span="4" ><span class="dCont">{{ CaseVisit.ELNRejected }}</span></el-descriptions-item> -->
                                <el-descriptions-item label="訪視成案率%" :span="6" ><span class="dCont">{{ CaseVisit.VisitSuccessRate }}</span></el-descriptions-item>
                            </el-descriptions>
                        </el-tab-pane>
                        <el-tab-pane label="訪視未成功統計">
                            <!--<el-descriptions :column="12" border>
                                <el-descriptions-item label="區處" :span="6" ><span class="dCont">北一區</span></el-descriptions-item>
                                <el-descriptions-item label="分行代號" :span="6" ><span class="dCont">103</span></el-descriptions-item>

                                 <el-descriptions-item label="訪視未成功名單" :span="4" ><span class="dCont">客戶拒絕</span></el-descriptions-item>
                                <el-descriptions-item label="未成功狀態件數" :span="4" ><span class="dCont">10</span></el-descriptions-item>
                                <el-descriptions-item label="未成功狀態%" :span="4" ><span class="dCont">10%</span></el-descriptions-item>
                                <el-descriptions-item label="未成功原因" :span="4">
                                    <div>
                                        <div style="padding: 5px 0;" class="dCont">暫無資金需求</div>
                                        <div style="padding: 5px 0;" class="dCont">已有往來行庫</div>
                                    </div>
                                </el-descriptions-item>
                                <el-descriptions-item label="未成功原因件數" :span="4">
                                    <div>
                                        <div style="padding: 5px 0;" class="dCont" >6</div>
                                        <div style="padding: 5px 0;" class="dCont" >4</div>
                                    </div>
                                </el-descriptions-item>
                                <el-descriptions-item label="未成功原因%" :span="4">
                                    <div>
                                        <div style="padding: 5px 0;" class="dCont" >60%</div>
                                        <div style="padding: 5px 0;" class="dCont" >40%</div>
                                    </div>
                                </el-descriptions-item> 
                            </el-descriptions>-->
                            <el-collapse v-model="activeCollapse" accordion style="margin-top: 20px;">
                                <el-collapse-item 
                                    v-for="(statusData, statusName) in statusSummary" 
                                    :key="statusName" 
                                    :name="statusName">
                                    <template slot="title">
                                        <strong style="font-size: 14px;">未成功訪視 : {{ statusName }}</strong>
                                        <span style="margin-left: 10px; color: #909399; font-size: 12px;">（件數：{{ statusData.StatusCount }}, 比例:{{ statusData.StatusRate }}）</span>
                                    </template>
                                    <el-table 
                                        :data="Object.entries(statusData.ReasonDetails).map(([reason, data]) => ({ reason, count: data.ReasonCount, rate: data.ReasonRate }))" 
                                        border 
                                        style="width: 100%; font-size: 13px;"
                                        :header-cell-style="{ fontSize: '13px' }">
                                        <el-table-column prop="reason" label="未成功原因" width="200" ></el-table-column>
                                        <el-table-column prop="count" label="件數" align="center"></el-table-column>
                                        <el-table-column prop="rate" label="比例" align="center"></el-table-column>
                                    </el-table>
                                </el-collapse-item>
                            </el-collapse>                            
                        </el-tab-pane>
                    </el-tabs>
                </div>




                <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center;">
                    <el-button type="primary" icon="el-icon-check"  @click="projectDetailVisible = false">確 定</el-button>
                    <el-button icon="el-icon-close" @click="projectDetailVisible = false">關閉</el-button>                    
                </span>
            </div>
            
        </el-dialog>
    </div>
</template>

<script>

import Pagination from '../../components/Pagination.vue';
import { notify, handleError } from '@/utils/notify.js';
import DivSelection from '../../components/DivSelection.vue';
import Breadcrumb from '../../components/Breadcrumb.vue';
import ExcelJS from 'exceljs';



export default {
    components: {
        Breadcrumb,
        Pagination,
        DivSelection
    },
    data() {
        return {
            btnDivVisible  : false,
            filterDivisionCode:'',
            // 新增圖表相關數據
            selectedBranch: null,
            // 若是HC, HE, HC1, HE1等帳號，則顯示區處分行選單
            showDivSelection: false,
            // Dialog 相關
            projectDetailVisible: false,
            selectedRow: null,



            tableData: [
            
            ],

            dt: [],

            pickerOptions: {
                shortcuts: [{
                    text: '最近一週',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一個月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三個月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }                }]
            },


            totalLists:0,

            listQuery: {
                Page_Size:10,
                Page_Num:1
            },   
            projectNameList: [],
            filteredProjectNameList: [],
            tableData: [],
            DivisionCode: [],
            CaseVisit: {
                "DivisionName": "",
                "DeptID": "",
                "DeptName": "",
                "VisitTotal": 0,
                "VisitComplete": 0,
                "VisitIncomplete": 0,
                "VisitCompleteRate": "0%",
                "ELNApproved": 0,
                "VisitSuccessRate": "0%"
            },

            statusSummary: {},
            activeCollapse: '',

        }        

        
    },
    methods: {

        handleDataSourceChange(val) {
            console.log("handleDataSourceChange", val);
            if( val!="全部" && val!=null && val!=""){
                // 過濾this.projectNameList，只保留DataSource等於val的專案名稱
                console.log("過濾前專案名稱列表", this.projectNameList);
                this.filteredProjectNameList = this.projectNameList.filter(item => item.DataSource === val);
                console.log("過濾後專案名稱列表", this.filteredProjectNameList);
            }
            else {
                // 若選擇全部，則顯示完整列表
                this.filteredProjectNameList = this.projectNameList;
            }
        },


        handleDivChange(val) {
            console.log("handleDivChange", val);
            // 現在 this.listQuery 已經存在，不會報錯
            this.DivisionCode = [val.DivisionCode, val.DeptID];

        },           

    

        async loadProjectNameList() {

            const qry = {
                "Page_Num": 1,
                "Page_Size": 999,
                
                // "DeptID": "string",
                // "UserID": "string"
            };
            try {
                const response = await this.$api.apicase.case_project(qry);
                console.log("專案名稱列表",response);
                const sourceList = Array.isArray(response.data) ? response.data : [];
                const projectMap = new Map();
                sourceList.forEach(item => {
                    const projectName = item && item.ProjectName ? String(item.ProjectName).trim() : '';
                    if (projectName && !projectMap.has(projectName)) {
                        projectMap.set(projectName, item);
                    }
                });
                this.projectNameList = Array.from(projectMap.values());
                this.filteredProjectNameList = this.projectNameList; // 初始化 filteredProjectNameList 為完整列表   

            } catch (error) {
                notify({
                    title: "錯誤",
                    message: "獲取專案名稱失敗，請稍後再試",
                    type: "error"
                });                
            }
        },        

        // 新增圖表交互方法
        handleBarClick(branchName) {
            console.log('選擇的分行：', branchName);
            this.selectedBranch = branchName;
        },

        async exportExcel() {
            if (!this.selectedRow || !this.selectedRow.ProjectName) {
                notify({
                    title: "警告",
                    message: "請先選擇專案後再匯出",
                    type: "warning"
                });
                return;
            }

            this.$store.dispatch("loadingHandler", true);
            try {
                // 先同步刷新統計資料，確保第1區匯出與畫面一致
                await this.doSearchVisit();

                const districtCodes = ['991', '992', '993', '994', '995', '996'];
                const baseQry = {
                    Page_Size: 9999,
                    Page_Num: 1,
                    Project_Name: this.selectedRow.ProjectName,
                };

                if (this.DivisionCode && this.DivisionCode.length > 0) {
                    baseQry.Division_Code = this.DivisionCode[0];
                    if (!districtCodes.includes(this.DivisionCode[1])) {
                        baseQry.DeptID = this.DivisionCode[1];
                    }
                }

                const completedQry = {
                    ...baseQry,
                    IsCompleted: 'Y'
                };
                const incompleteQry = {
                    ...baseQry,
                    IsCompleted: 'N'
                };

                const [completedRes, incompleteRes] = await Promise.all([
                    this.$api.apicase.case_list(completedQry),
                    this.$api.apicase.case_list(incompleteQry)
                ]);

                const completedRows = (completedRes && completedRes.data) ? completedRes.data : [];
                const incompleteRows = (incompleteRes && incompleteRes.data) ? incompleteRes.data : [];

                const formatApprovedStatus = (status) => {
                    if (status === 'approved') return '已覆核';
                    if (status === 'rejected') return '退回承辦';
                    if (status === 'pending') return '待覆核';
                    return status || '';
                };

                const mapCaseRows = (rows) => rows.map(r => ({
                    '案件編號': r.CaseNo || '',
                    '建立時間': r.CreateDt || '',
                    '案件狀態': r.CaseStatus || '',
                    '核准金額': r.ApproveAmount || '',
                    '案件原因': r.CaseReason || '',
                    '原因說明': r.CaseReasonDescription || '',
                    '覆核狀態': formatApprovedStatus(r.ApprovedStatus),                    
                    '區處': r.DivisionName || '',                    
                    '分行名稱': r.DeptName || '',
                    '承辦人': r.AssigneeUserName || '',
                    '預計訪視時間': r.ExpectVisitDt || '',
                    '統一編號': r.UniComNm || '',
                    '公司名稱': r.ComName || '',
                    '資料來源': r.Source || '',
                    '專案名稱': r.ProjectName || '',
                    '到期日/限辦日期': r.CloseDt || '',
                    '備註': r.Memo || '',
                    
                }));

                const completedExportRows = mapCaseRows(completedRows);
                const incompleteExportRows = mapCaseRows(incompleteRows);

                const aoa = [];
                const merges = [];
                const maxCols = 17;
                const sectionRanges = [];

                const pushMergedTitle = (title) => {
                    const rowIndex = aoa.length;
                    aoa.push([title]);
                    merges.push({ s: { r: rowIndex, c: 0 }, e: { r: rowIndex, c: maxCols - 1 } });
                    return rowIndex;
                };

                // 第1區：訪視完成統計
                const summaryTitleRow = pushMergedTitle('訪視完成統計');
                aoa.push(['專案名稱', this.selectedRow.ProjectName || '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']);
                aoa.push(['訪視名單', this.CaseVisit.VisitTotal || 0, '已完成訪視', this.CaseVisit.VisitComplete || 0, '未完成訪視', this.CaseVisit.VisitIncomplete || 0, '已完成訪視%', this.CaseVisit.VisitCompleteRate || '0%', '', '', '', '', '', '', '', '', '']);
                aoa.push(['ELN核准', this.CaseVisit.ELNApproved || 0, '訪視成案率%', this.CaseVisit.VisitSuccessRate || '0%', '', '', '', '', '', '', '', '', '', '', '', '', '']);
                sectionRanges.push({ type: 'summary', startRow: summaryTitleRow, endRow: aoa.length - 1 });
                aoa.push([]);

                // 第2區：已完成訪視名單
                const completedTitleRow = pushMergedTitle('已完成訪視名單');
                if (completedExportRows.length > 0) {
                    const header2 = Object.keys(completedExportRows[0]);
                    aoa.push(header2);
                    completedExportRows.forEach(item => {
                        aoa.push(header2.map(k => item[k]));
                    });
                } else {
                    aoa.push(['無資料']);
                }
                sectionRanges.push({ type: 'table', startRow: completedTitleRow, endRow: aoa.length - 1 });
                aoa.push([]);

                // 第3區：未完成訪視名單
                const incompleteTitleRow = pushMergedTitle('未完成訪視名單');
                if (incompleteExportRows.length > 0) {
                    const header3 = Object.keys(incompleteExportRows[0]);
                    aoa.push(header3);
                    incompleteExportRows.forEach(item => {
                        aoa.push(header3.map(k => item[k]));
                    });
                } else {
                    aoa.push(['無資料']);
                }
                sectionRanges.push({ type: 'table', startRow: incompleteTitleRow, endRow: aoa.length - 1 });

                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('訪視統計');

                aoa.forEach(row => {
                    worksheet.addRow(row);
                });

                merges.forEach(merge => {
                    worksheet.mergeCells(
                        merge.s.r + 1,
                        merge.s.c + 1,
                        merge.e.r + 1,
                        merge.e.c + 1
                    );
                });

                const colWidths = [14, 16, 14, 18, 14, 16, 14, 14, 12, 12, 16, 20, 12, 18, 14, 20, 18];
                colWidths.forEach((width, index) => {
                    worksheet.getColumn(index + 1).width = width;
                });

                const thinBorder = {
                    top: { style: 'thin', color: { argb: 'FFD9D9D9' } },
                    bottom: { style: 'thin', color: { argb: 'FFD9D9D9' } },
                    left: { style: 'thin', color: { argb: 'FFD9D9D9' } },
                    right: { style: 'thin', color: { argb: 'FFD9D9D9' } }
                };

                const applyStyle = (cell, style) => {
                    if (style.font) cell.font = style.font;
                    if (style.fill) cell.fill = style.fill;
                    if (style.alignment) cell.alignment = style.alignment;
                    if (style.border) cell.border = style.border;
                };

                const ensureCell = (rowIndex, colIndex) => {
                    const row = worksheet.getRow(rowIndex + 1);
                    const cell = row.getCell(colIndex + 1);
                    if (cell.value === null || cell.value === undefined) {
                        cell.value = '';
                    }
                    return cell;
                };

                const styleRow = (rowIndex, fromCol, toCol, style) => {
                    for (let colIndex = fromCol; colIndex <= toCol; colIndex += 1) {
                        const cell = ensureCell(rowIndex, colIndex);
                        applyStyle(cell, style);
                    }
                };

                const titleStyle = {
                    font: { bold: true, size: 14 },
                    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFF6EF' } },
                    alignment: { horizontal: 'center', vertical: 'middle' },
                    border: thinBorder
                };

                const headerStyle = {
                    font: { bold: true },
                    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFF6EF' } },
                    alignment: { horizontal: 'center', vertical: 'middle', wrapText: true },
                    border: thinBorder
                };

                const bodyStyle = {
                    alignment: { vertical: 'middle', wrapText: true },
                    border: thinBorder
                };

                const summaryLabelStyle = {
                    font: { bold: true },
                    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFF6EF' } },
                    alignment: { horizontal: 'center', vertical: 'middle' },
                    border: thinBorder
                };

                const summaryValueStyle = {
                    font: { bold: true },
                    alignment: { horizontal: 'center', vertical: 'middle' },
                    border: thinBorder
                };

                sectionRanges.forEach(section => {
                    styleRow(section.startRow, 0, maxCols - 1, titleStyle);

                    if (section.type === 'summary') {
                        for (let rowIndex = section.startRow + 1; rowIndex <= section.endRow; rowIndex += 1) {
                            for (let colIndex = 0; colIndex < maxCols; colIndex += 1) {
                                const cell = ensureCell(rowIndex, colIndex);
                                const value = cell.value;
                                const isLabelCell = value && typeof value === 'string' && colIndex % 2 === 0;
                                applyStyle(cell, isLabelCell ? summaryLabelStyle : summaryValueStyle);
                            }
                        }
                    } else {
                        const headerRow = section.startRow + 1;
                        const dataStartRow = section.startRow + 2;
                        styleRow(headerRow, 0, maxCols - 1, headerStyle);
                        for (let rowIndex = dataStartRow; rowIndex <= section.endRow; rowIndex += 1) {
                            styleRow(rowIndex, 0, maxCols - 1, bodyStyle);
                        }
                    }
                });

                const now = new Date();
                const ts = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}_${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}`;
                const safeProjectName = String(this.selectedRow.ProjectName || '專案').replace(/[\\/:*?"<>|]/g, '_');
                const fileName = `${safeProjectName}_訪視統計_${ts}.xlsx`;

                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                // 要做一個稽核記錄.. 呼叫後端 API 紀錄匯出行為                
                const setAudit = {
                    "menu_path": ["客戶分析", "客戶名單分析","專案訪視統計表"],
                    "action_type": "export",
                    "action_name": "匯出",
                    "details": {
                        "project_name": this.selectedRow.ProjectName
                        
                    }
                }
                const resp = await this.$api.apimgrs.setAuditLog(setAudit);   

                notify({ title: '成功', message: `已下載 ${fileName}`, type: 'success' });
            } catch (error) {
                console.error('匯出訪視統計失敗', error);
                notify({ title: '錯誤', message: '匯出失敗，請稍後再試', type: 'error' });
            } finally {
                this.$store.dispatch("loadingHandler", false);
            }
        },

        async projectDetailHandler(row) {
            this.selectedRow = row;
            console.log("選中行資料", this.selectedRow);
            this.doSearchVisit();
            this.projectDetailVisible = true;
        },

        handleClose(done) {
            this.selectedRow = null;
            done();
        },

        doSearch() {     
            this.listQuery.Page_Num = 1;                   
            this.getList();
        },

        async doSearchVisit() {           

            const qry = {
                "ProjectName": this.selectedRow.ProjectName,
            };       
            
            const roleName = this.$store.getters.userRole || '';
            const deptID = this.$store.getters.deptID || '';

            if( roleName=="UC") {
                qry.DeptID = deptID;
            }

            if( roleName=="HC1"){
                const funs = this.$store.getters.userInfo;
                const branchArea = funs.DivisionCode;                
                 qry.DivisionCode = branchArea;
            }

            if( this.DivisionCode.length>0 ){
                qry.DivisionCode = this.DivisionCode[0];       
                console.log("DivisionCode", this.DivisionCode);         
                // 若是選擇了區處，則帶入 DivisionCode 查詢；若是選擇了分行，則帶入 DeptID 查詢，這樣後端就可以根據不同的條件進行統計查詢
                // 只有當 DeptID 不是區處代碼時，才設置 qry.DeptID
                const districtCodes = ['991', '992', '993', '994', '995', '996'];
                if( !districtCodes.includes(this.DivisionCode[1]) ){
                    qry.DeptID = this.DivisionCode[1];
                }
                else {
                    qry.DivisionCode = this.DivisionCode[0]; 
                }
            }
            console.log("查詢參數 - 訪視完成統計",qry); 
            
            const visitPromise = this.$api.apianalysis.getCaseAnalysisVisit(qry).then(response => {
                console.log("專案訪視完成統計回傳資料",response);
                if( response.statuscode==200 && response.data.length>0 ){ 
                    this.CaseVisit = response.data[0];                
                    console.log("專案訪視完成統計",this.CaseVisit);
                } else {
                    this.CaseVisit = {
                        "DivisionName": "",
                        "DeptID": "",
                        "DeptName": "",
                        "VisitTotal": 0,
                        "VisitComplete": 0,
                        "VisitIncomplete": 0,
                        "VisitCompleteRate": "0%",
                        "ELNApproved": 0,
                        "VisitSuccessRate": "0%"
                    };                 
                    notify({
                        title: "訊息",
                        message: "查無資料，請重新選擇區處分行",
                        type: "info"
                    });                                
                }                
            }).catch(error => {
                notify({
                    title: "錯誤",
                    message: "獲取專案訪視完成統計失敗，請稍後再試",
                    type: "error"
                });                
            });    
            
            const qryIncomplete = {
                "AnalysisType": "incomplete",
                "ProjectName": this.selectedRow.ProjectName,
            };

            if( this.DivisionCode.length>0 ){
                qryIncomplete.DivisionCode = this.DivisionCode[0];                
                // 只有當 DeptID 不是區處代碼時，才設置 qry.DeptID
                const districtCodes = ['991', '992', '993', '994', '995', '996'];
                if( !districtCodes.includes(this.DivisionCode[1]) ){
                    qryIncomplete.DeptID = this.DivisionCode[1];
                } 
                else {
                    qryIncomplete.DivisionCode = this.DivisionCode[0]; 
                }
            }            

            console.log("查詢參數-未完成",qryIncomplete);
            const incompletePromise = this.$api.apianalysis.getCaseAnalysisComplete(qryIncomplete).then(response => {
                console.log("專案訪視未完成統計回傳資料",response);
                // 需要針對回傳資料response.data進行處理，更新畫面上的未完成統計資訊
//                 {
//     "DivisionName": "北一區",
//     "DeptID": "103",
//     "CaseStatus": "其他",
//     "StatusCount": 3,
//     "StatusRate": "50%",
//     "CaseReason": "停歇業",
//     "ReasonCount": 2,
//     "ReasonRate": "67%"
// }
                // 針對 CaseStatus 和 CaseReason 進行彙總處理
                let statusSummary = {};
                response.data.forEach(item => {
                    if (!statusSummary[item.CaseStatus]) {
                        statusSummary[item.CaseStatus] = {
                            StatusCount: 0,
                            ReasonDetails: {}
                        };
                    }
                    statusSummary[item.CaseStatus].StatusCount = item.StatusCount;
                    statusSummary[item.CaseStatus].StatusRate = item.StatusRate;

                    if (!statusSummary[item.CaseStatus].ReasonDetails[item.CaseReason]) {
                        statusSummary[item.CaseStatus].ReasonDetails[item.CaseReason] = {
                            ReasonCount: 0
                        };
                    }
                    statusSummary[item.CaseStatus].ReasonDetails[item.CaseReason].ReasonCount += item.ReasonCount;
                    statusSummary[item.CaseStatus].ReasonDetails[item.CaseReason].ReasonRate = item.ReasonRate;
                });
                console.log("未完成狀態彙總", statusSummary);
                this.statusSummary = statusSummary;
                
                // 設置第一個折疊面板為預設打開
                const firstKey = Object.keys(statusSummary)[0];
                if (firstKey) {
                    this.activeCollapse = firstKey;
                }

                // 處理未完成統計資料
            }).catch(error => {
                notify({
                    title: "錯誤",
                    message: "獲取專案訪視未完成統計失敗，請稍後再試",
                    type: "error"
                });                
            });

            await Promise.all([visitPromise, incompletePromise]);

            
        },


        async getList() {
            
            this.$store.dispatch("loadingHandler", true);
            console.log("取得列表資料", this.listQuery);
            
            const qry = {
                "Page_Num": this.listQuery.Page_Num,
                "Page_Size": this.listQuery.Page_Size
            };
            
            // 添加資料來源條件
            if (this.listQuery.DataSource && this.listQuery.DataSource != '全部') {
                qry.DataSource = this.listQuery.DataSource;
            }
            
            // 添加專案名稱條件
            if (this.listQuery.ProjectName && this.listQuery.ProjectName != '全部') {
                qry.ProjectName = this.listQuery.ProjectName;
            }
            
            // 添加日期範圍條件
            if (this.dt && this.dt.length === 2) {
                qry.CreateDtStart = this.$dayjs(this.dt[0]).format('YYYY-MM-DD');
                qry.CreateDtEnd = this.$dayjs(this.dt[1]).format('YYYY-MM-DD');
            }

            qry.GroupByDeptID = true; // 加入分行彙總的參數，讓後端知道需要回傳分行彙總資料
            console.log("查詢參數", qry);
            try {
                const response = await this.$api.apicase.case_project(qry);
                console.log("列表資料",response);
                this.tableData = Array.isArray(response.data) ? response.data : [];
                this.totalLists = response.total || this.tableData.length;
            } catch (error) {
                notify({
                    title: "錯誤",
                    message: "獲取專案名稱失敗，請稍後再試",
                    type: "error"
                });                
            } finally {
                this.$store.dispatch("loadingHandler", false);
            }
        },        

        async pageChange(val) {
            this.listQuery.Page_Num = val;
            await this.getList();
        },

        handleSelectionChange(val) {
            console.log("checked",val);
            this.selectData = val;
        },   
        
        getFunction() {
            const roleName = this.$store.getters.userRole || '';
            // HE, HC1, HD, HC 部門可以選取btnDivVisible
            if( roleName.includes('HE') || roleName.includes('HC1') || roleName.includes('HD') || roleName.includes('HC') ){
                this.btnDivVisible = true;
            } else {
                this.btnDivVisible = false;
            }   

            console.log("帳號角色", roleName);
            // 決定DivSelect元件顯示的層級
            if( roleName=="HE" || roleName=="HC1" || roleName=="UC" ){
                const funs = this.$store.getters.userInfo;
                const branchArea = funs.DivisionCode;
                console.log('branchArea:', branchArea);
                this.filterDivisionCode = branchArea;
            }              
        }

    },    


    computed: {

    },


    async mounted() {
        this.$store.dispatch("loadingHandler", true);
        let today = new Date();
        let threeMonthsAgo = new Date();
        threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
        this.dt = [threeMonthsAgo, today];
        this.totalLists = this.tableData.length;     

        this.getFunction()        
        this.loadProjectNameList();
        await this.getList();
        this.$store.dispatch("loadingHandler", false);
    }    
}

</script>

<style lang="scss" scoped>

#caseProgBox {
  background: linear-gradient(-135deg, #FFF 20%, #fff 50%, transparent 50%)
    center center / 100% 100%;
  min-height: 100vh;
  padding: 0px 0%;


  .datePickerClass {
    margin-right: 10px;
    font-weight: bold;
  }

  .dialogBox {
    display: flex;
    flex-direction: column;;    
    justify-content: flex-start;
    
    padding: 0px 5%;
    .row1 {
        display: flex;
        flex-direction: row;    
        justify-content: flex-start;        
        margin-bottom: 1rem;
        
        .itemBox {
            display: flex;
            flex-direction: row;    
            justify-content: flex-start;
            align-items: center;
            margin: 10px 10px;
            width: 50%;            

            label {            
                white-space: nowrap;
                font-weight: bold;
                font-size:medium;
            }
            button {
                text-align: right;
            }
        }
    }
    .row3 {
      width:100%;      
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      
      .itemWrap {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;  
        width: 100%;
        

      }
    }      
  }


  .searchWrap   {
    display: flex;
    flex-direction: row;    
    justify-content: flex-start;
    padding: 0px 5%;
    .row {
        display: flex;
        flex-direction: row;    
        justify-content: center;

        .itemWrap {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            margin-top:20px; 
            margin-right: 15px;
            margin-bottom: 20px;
            
            label {                
                white-space: nowrap;
                margin-right: 10px;
                text-align: right;
            }            
        }
    }
    .row3 {
      width:100%;      
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      
      .itemWrap {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        justify-content: flex-end;
      }
    }     
  }

  .buttonBox {
    padding: 0 5%;
    display: flex;
    justify-content: center;

  }

  .content {
    display: flex;
    flex-direction: column;    
    justify-content: flex-start;
    margin-top: 20px;
    padding: 0px 5%;
    .legend {
        display: flex;
        flex-direction: row;
        .legendItem {
            width: 80px;
            margin: 5px 10px;
        }
        
    }

  }  
  .pageBox {
    display: flex;
    flex-direction: columns;    
    justify-content: flex-end;
    padding: 0px 5%;
   }  

  .goDetailPage {
    color: #0645ad;
    text-decoration: underline;
    cursor: pointer;
   }

  .clickable-text {
    color: #0645ad;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }

    .dCont {        
        width: 100% !important;
        font-weight: bold;
        color: #333;
    }

    ::v-deep .el-collapse-item__header {
        background-color: #F2F6FC ;
        outline: gray solid 1px;
        color: black;
        font-weight: bold;
        padding: 12px 16px;
    }

    ::v-deep .el-collapse-item__arrow {
        color: black;
    }
}

</style>

